import React from "react";
import Hero from "./Hero";
import Home from "./Home";
import { motion } from "framer-motion";
function Main() {
  return (
    <motion.div
      className="services"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3, ease: "easeInOut" } }}
      exit={{ opacity: 0, transition: { duration: 0.3, ease: "easeInOut" } }}
    >
      <Hero />
      <Home />
    </motion.div>
  );
}

export default Main;
